import React from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from "@material-ui/core/styles";

import ListPost from './Posts/ListPost'
import Login from './Auth/Login'
import HomeLayout from './Layout/HomeLayout';

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
  },
}));

const Home = () => {
  const classes = useStyles();
  const isAuthenticated = useSelector(state => !!state.auth.isAuthenticated);
  const user = useSelector(state => state.auth.user);

  return (
    <div className={classes.container}>
      {isAuthenticated ? <ListPost data={user} /> : <HomeLayout />}
    </div>
  )
}

export default Home;
